export default __webpack_public_path__ + "static/media/card1.9ff9064b.png";